import UserStatisticApi from '@/api/rest/UserStatistics';

export default new UserStatisticApi();
